"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Password = void 0;

var react_1 = __importStar(require("react"));

var Form_1 = __importDefault(require("../Form/Form"));

var Input_1 = __importDefault(require("../Form/Input"));

var Password_1 = __importDefault(require("../../models/Password"));

var utils_1 = require("./utils");

var PasswordRules_1 = __importDefault(require("./PasswordRules"));

var react_theme_components_1 = require("@suezenv/react-theme-components");

var password = Password_1.default.password,
    repeated_password = Password_1.default.repeated_password;

exports.Password = function (_a) {
  var onSubmit = _a.onSubmit;

  var _b = __read(react_1.useState(utils_1.checkPassRules('')), 2),
      passwordValidation = _b[0],
      setPasswordValidation = _b[1];

  return react_1.default.createElement(Form_1.default, {
    className: "no-gutters",
    onSubmit: onSubmit,
    validationSchema: Password_1.default,
    initialValues: {}
  }, function (_a) {
    var isValid = _a.isValid;

    var onBlur = function onBlur(_a) {
      var target = _a.target;
      setPasswordValidation(utils_1.checkPassRules(target.value));
    };

    return react_1.default.createElement(react_theme_components_1.SzBox, {
      className: "col-12 pr-md-3"
    }, react_1.default.createElement("div", {
      className: "row"
    }, react_1.default.createElement("div", {
      className: "col-5 offset-1"
    }, react_1.default.createElement(Input_1.default, __assign({}, password, {
      className: "col-md-12 p-0",
      name: 'password',
      onBlur: onBlur,
      showPassword: true
    })), react_1.default.createElement(Input_1.default, __assign({}, repeated_password, {
      className: "col-md-12 p-0",
      name: 'repeated_password',
      onBlur: onBlur,
      showPassword: true
    }))), react_1.default.createElement(react_theme_components_1.SzBox, {
      className: "col-6"
    }, react_1.default.createElement(PasswordRules_1.default, {
      passwordValidation: passwordValidation
    }))), react_1.default.createElement("div", {
      className: "row"
    }, react_1.default.createElement(react_theme_components_1.SzBox, {
      className: "col-5 offset-1"
    }, react_1.default.createElement(react_theme_components_1.SzButton, {
      variant: "tertiary",
      icon: "arrow-left",
      className: "d-none d-sm-flex"
    }, "Retour \xE0 la page de connexion")), react_1.default.createElement(react_theme_components_1.SzBox, {
      className: "col-6"
    }, react_1.default.createElement(react_theme_components_1.SzButton, {
      type: "submit",
      isDisabled: !isValid,
      className: "float-right"
    }, "Enregistrer les modifications"))));
  });
};

exports.default = exports.Password;